import { useTranslation } from 'react-i18next';
import 'react-step-progress-bar/styles.css';
import { useStateSelector } from '../../../../store';
import Stepper from './Stepper';
import { useLocale } from '../../../../hooks/useLocale';

export enum ManageCreatePropertySteps {
  BASIC_DETAILS = 1,
  UNIT_DETAILS = 49,
  DOCUMENTS = 99,
  COMPLETED = 100,
}

const ManageCreatePropertyProgressBar = ({
  onProgressBarClick,
}: {
  onProgressBarClick: (step: ManageCreatePropertySteps) => void;
}) => {
  const { t } = useTranslation();
  const { currentTabStep, property } = useStateSelector((s) => s.propertyUnits);
  const { dir } = useLocale();
  const steps = [
    t('pages.properties.create_property.basic_details'),
    t(
      property.isSeperateOwnership
        ? 'property.units_details'
        : 'pages.properties.create_property.units_details'
    ),
    t('pages.properties.property_details.documents'),
  ];

  // Calculate the current step index based on the currentTabStep value
  const currentStepIndex = (() => {
    switch (currentTabStep) {
      case ManageCreatePropertySteps.BASIC_DETAILS:
        return 0;
      case ManageCreatePropertySteps.UNIT_DETAILS:
        return 1;
      case ManageCreatePropertySteps.DOCUMENTS:
        return 2;
      default:
        return 0; // Default to the first step if currentTabStep is not recognized
    }
  })();

  return (
    <div className="w-full px-5">
      <Stepper
        currentStep={currentStepIndex}
        dir={dir}
        steps={steps}
        onProgressBarClick={(i) => {
          onProgressBarClick(
            i === 0
              ? ManageCreatePropertySteps.BASIC_DETAILS
              : i === 1
              ? ManageCreatePropertySteps.UNIT_DETAILS
              : ManageCreatePropertySteps.DOCUMENTS
          );
        }}
      />
    </div>
  );
};

export default ManageCreatePropertyProgressBar;
